import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getDefaultLandingRoute } from '../utils/permissionUtils';
import { NavigationConfig } from '../utils/navigation_config';
var DefaultLanding = function () {
    var navigate = useNavigate();
    var userBasicInfo = useSelector(function (store) { return store.User.userData; });
    var isLoggedIn = useSelector(function (store) { return store.User.isLoggedIn; });
    var rolePermissions = (userBasicInfo === null || userBasicInfo === void 0 ? void 0 : userBasicInfo.RolePermissions) || [];
    var hasNavigated = useRef(false);
    useEffect(function () {
        if (hasNavigated.current)
            return;
        if (!isLoggedIn) {
            hasNavigated.current = true;
            navigate(NavigationConfig.Account.Login);
        }
        else if (isLoggedIn && userBasicInfo && rolePermissions.length > 0) {
            var defaultRoute = getDefaultLandingRoute(rolePermissions);
            hasNavigated.current = true;
            navigate(defaultRoute, { replace: true });
        }
    }, [isLoggedIn, rolePermissions.length, userBasicInfo, navigate]);
    return null;
};
export default DefaultLanding;
